import React, { Component } from 'react';
import $ from 'jquery';

import AdminLayout from './layout';

import FetchCall from '../../API/FetchCall';
import { getExclusivePartnersPaged, removeExclUser } from '../../API/FetchCall';
//import { Editor } from '@tinymce/tinymce-react';
import { adminUser, userExport, deactivateUser, activateUser, commonAPI } from '../../API/FetchCall';

import 'react-notifications/lib/notifications.css';
import {NotificationContainer, NotificationManager} from 'react-notifications';

class exclusivePartnerList extends Component {

    constructor(props) {
        super(props);
        var url = new URL(window.location.href);
        var location = url.searchParams.get("location");
        var auth_data = JSON.parse(localStorage.getItem("user_data"));
        this.state = {
              logged: localStorage.getItem("authentication"),
              auth_data: JSON.parse(localStorage.getItem("user_data")),
              location: location ? location.split('-') : [],
              exclpartnerList: [],
        };

        this.getList();
    }


    componentDidMount() {

      var THIS = this;
      $(document).on('click', '.remove_exclpartners', function () {
        var delete_id = $(this).data("id");
        THIS.deleteUser(delete_id);
      });

    }




    deleteUser(delete_id = '') {
    if(confirm("Are you sure to remove this user and info?")== true) {
            let ins = JSON.stringify({
                id: delete_id                
            });
            removeExclUser(ins).then((res) => {
                let toastr = '';
                if (res.status === 1) {
                    
                    NotificationManager.success(res.message);

                    setTimeout(function () {
                        window.location.reload();
                    }, 2000);
                } else {
                    
                    NotificationManager.error(res.message);
                }
            });
        }
   }


    getList = () => {
      const { login_id, role } = this.state.auth_data;
      let req = JSON.stringify({
            role: role,
            path: window.location.pathname,
            location: this.state.location,
            year: this.state.year,
            month: this.state.month
        })
      getExclusivePartnersPaged(req).then((res) => {
        if (res.status == 1) {
          this.setState({
            exclpartnerList: res.data
            
          });
        } else {
          this.setState({
            exclpartnerList: [],
          });
        }
      });
    }    

    render() {

        const { exclpartnerList } = this.state;

        return (
            <React.Fragment>
                <AdminLayout>
                    
           <div class="col-lg-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">Exclusive Partners</h4>
                                   
                  <div class="float-right"><a href="/users/exclusivepartners/add" class="btn btn-primary btn-sm">Add</a></div>
                   
                  <div class="table-responsive pt-3">
                     <table class="table table-bordered table-striped">
                      <thead class="thead-dark">
                        <tr>
                          <th>
                            <strong>S.No</strong>
                          </th>
                       
                          <th>
                            <strong>Name</strong>
                          </th>
                          
                         
                          <th>
                            <strong>Email Id</strong>
                          </th>

                          <th>
                            <strong>Type</strong>
                          </th>

                          <th>
                            <strong>Created Date</strong>
                          </th>
                          
                          <th>
                            <strong>Action</strong>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                      {exclpartnerList.map((item, i) => {     
                      
                       return <tr>
                          <td>
                            {i+1}
                          </td>
                          <td>
                           {item.user_name}
                          </td>
                           
                          
                          <td>
                           {item.email_id}
                          </td>
                          <td>
                            {(item.optiontoshow=='both')?"B2B/B2C":(item.optiontoshow=='onlyparents')?'B2C':(item.optiontoshow=='onlypartners')?'B2B':'undefined'}
                          </td>

                          <td>
                            {item.date}
                          </td>
                          
                          
                          <td  class="actionbtns exclusivepartnrs" dangerouslySetInnerHTML={{__html: item.action}} />                            

                        </tr>

                      })

                      }
                       
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <NotificationContainer />
                </AdminLayout>
            </React.Fragment>
        )
    }
}


export default exclusivePartnerList;


// WEBPACK FOOTER //
// ./src/components/bewise/exclusivePartnerList.jsx